import type * as Types from '../types';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import document from './emptyQuery.gql';
import type * as ApolloReactCommon from '~/lazy_apollo/client';
import * as ApolloReactHooks from '~/lazy_apollo/client';
export type EmptyQuery_popmenuConfig_PopmenuConfig = {
  __typename: 'PopmenuConfig',
  id: number
};

export type EmptyQuery_Query = {
  __typename?: 'Query',
  popmenuConfig: EmptyQuery_popmenuConfig_PopmenuConfig
};


export type EmptyQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type EmptyQuery = EmptyQuery_Query;


export const EmptyDocument = /*#__PURE__*/ document as unknown as DocumentNode<EmptyQuery, EmptyQueryVariables>;


/**
 * __useEmptyQuery__
 *
 * To run a query within a React component, call `useEmptyQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmptyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param options options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmptyQuery({
 *   variables: {
 *   },
 * });
 */
export function useEmptyQuery(options?: ApolloReactHooks.QueryHookOptions<EmptyQuery, EmptyQueryVariables>) {
                return ApolloReactHooks.useQuery<EmptyQuery, EmptyQueryVariables>(EmptyDocument, options);
      }
export function useEmptyLazyQuery(options?: ApolloReactHooks.LazyQueryHookOptions<EmptyQuery, EmptyQueryVariables>) {
                    return ApolloReactHooks.useLazyQuery<EmptyQuery, EmptyQueryVariables>(EmptyDocument, options);
        }
export function useEmptySuspenseQuery(options?: ApolloReactHooks.SuspenseQueryHookOptions<EmptyQuery, EmptyQueryVariables>) {
                    return ApolloReactHooks.useSuspenseQuery<EmptyQuery, EmptyQueryVariables>(EmptyDocument, options);
        }
export type EmptyQueryHookResult = ReturnType<typeof useEmptyQuery>;
export type EmptyLazyQueryHookResult = ReturnType<typeof useEmptyLazyQuery>;
export type EmptySuspenseQueryHookResult = ReturnType<typeof useEmptySuspenseQuery>;
export type EmptyQueryResult = ApolloReactCommon.QueryResult<EmptyQuery, EmptyQueryVariables>;